"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossSiteFormsManager = void 0;
const query_1 = require("./query");
class CrossSiteFormsManager {
    static get isViewOnly() {
        return query_1.Z.one('#process-form').action == '#';
    }
    constructor() {
        if (window['CSF']) {
            CrossSiteFormsManager.instance = window['CSV'];
            return;
        }
        console.log(`Initialised cross-site forms manager`);
        if (!CrossSiteFormsManager.instance) {
            CrossSiteFormsManager.instance = this;
        }
        window['CSF'] = this;
    }
    updateForm(src = null, values = null, action = 'edit') {
        if (CrossSiteFormsManager.isViewOnly)
            return;
        console.log(`updateForm [${action}]`, src, values);
        if (values) {
            query_1.Z.setValues(values);
        }
        query_1.Z.setValue('#cap-form-action', action);
        query_1.Z.submitFormAsync(src, query_1.Z.one('#process-form'), resp => {
            //console.log(`response: `, resp);
            if (action == 'approve' || action == 'submit' || action == 'cancel' || ('' + resp).startsWith('/')) {
                query_1.Z.go(src, resp);
                return;
            }
            let focusedElement = query_1.Z.first('.cap-form *:focus');
            let focusedElementId = focusedElement ? focusedElement.id : null;
            query_1.Z.forFirst('.cap-form .form-content', content => {
                query_1.Z.empty(content);
                //let dom = Z.parseHtmlAsTemplate('<template>' + resp + '</template>');
                content.innerHTML = resp;
                //console.log(resp);
                //console.log(content);
                //content.append(dom);
            });
            if (focusedElementId)
                query_1.Z.focus(`#${focusedElementId}`);
            query_1.Z.show('.hide-when-verified');
            query_1.Z.hide('.show-when-verified');
            if (action == 'verify') {
                query_1.Z.forEach('#verify-form-button', el => {
                    el.classList.remove('btn-info');
                    el.classList.add('btn-success');
                });
                query_1.Z.forFirst('#verify-form-button > span', el => el.innerText = ` Verified!`);
                query_1.Z.forFirst('#verify-form-button > i', el => el.replaceWith(query_1.Z.parseHtmlAsTemplate('<i class="fas fa-fw fa-check"></i>')));
                query_1.Z.show('.show-when-verified');
                query_1.Z.hide('.hide-when-verified');
                setTimeout(() => {
                    query_1.Z.forEach('#verify-form-button', el => {
                        el.classList.remove('btn-success');
                        el.classList.add('btn-info');
                    });
                    query_1.Z.forFirst('#verify-form-button > span', el => el.innerText = ' Verify');
                    query_1.Z.forFirst('#verify-form-button > i', el => el.replaceWith(query_1.Z.parseHtmlAsTemplate('<i class="fas fa-fw fa-info-circle"></i>')));
                }, 1000);
            }
            query_1.Z.updateLayout();
        });
    }
}
exports.CrossSiteFormsManager = CrossSiteFormsManager;
//# sourceMappingURL=crossSiteFormsManager.js.map